import sporttakApi from "../../../api/sporttakApi";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrSuccess, showToastrWarning } from "../../../util/toastr";
import mergeDeep from "../../../util/mergeDeep";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";

import assign from 'object-assign';

export default class SporttakPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;
		const isNew = context.props.isNew;
		const disabled = context.props.disabled;

		ajaxActions.started();
		if (transactieId) {
			sporttakApi.list(transactieId, isNew)
				.then((response) => {
					ajaxActions.ended();
					this.processModel(response.data, {}, '', false);
				})
				.catch((ex) => {
					ajaxActions.failed();
					if (ex && ex.response && ex.response.status === 404) {
						showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
						context.setState({ hasUnsavedChanges: false });
						context.props.setHasUnsavedChanges(false);
						this.redirector.goTo("/federatie/overzicht");
					}
					else {
						context.props.throwException(ex, true);
					}
				});
		}

		context.setState({
			transactieId
		});
	}

	save() {
		const context = this.context;
		const state = context.state;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;

		let errors = null;
		let model = null;

		const modelToSave = {
			transactionId: transactieId,
			model: {
				id: state.sportclubId,
				sporttakken: state.models,
				sportclubNaam: state.sportclubNaam,
				checkedSporttakken: state.checkedSporttakken.concat(state.indeterminateSporttakken.filter(s => state.checkedSporttakken.indexOf(s === -1)))
			}
		};

		ajaxActions.started();
		return sporttakApi.save(modelToSave).then((response) => {
			ajaxActions.ended();
			let hasUnsavedChanges = context.hasUnsavedChanges;
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				hasUnsavedChanges = false;
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}
			let validationMessageType = response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING;
			this.processModel(model, errors, validationMessageType, hasUnsavedChanges);
		})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					context.props.setHasUnsavedChanges(false);
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	processModel(response, validationResults, validationMessageType, hasUnsavedChanges) {
		const context = this.context;
		const state = context.state;
		let errors = validationResults;
		const models = response.model.sporttakken.map(x => mergeDeep({}, x));
		const checkedSporttakken = assign([], response.model.checkedSporttakken);
		let indeterminateSporttakken = assign([], state.indeterminateSporttakken);

		const tabSettings = response.tabSettings;
		context.props.setTabSettings(tabSettings);

		if (response.transactionId)
			context.props.setActiveTransaction(response.transactionId);

		context.setState({
			models,
			errors,
			validationMessageType,
			shouldScrollToFirstError: true,
			hasUnsavedChanges: hasUnsavedChanges,
			undoButtonDisabled: true,
			level: -1,
			sportclubNaam: response.model.sportclubNaam || "Nieuwe sportclub"
		});
		context.props.setHasUnsavedChanges(hasUnsavedChanges);

		response.model.checkedSporttakken.map(s => this.setRootCheckbox(checkedSporttakken, indeterminateSporttakken, s, models));

		const original = mergeDeep({}, {
			models,
			checkedSporttakken,
			indeterminateSporttakken
		}, original);

		context.setState({
			original,
			indeterminateSporttakken,
			checkedSporttakken
		});
	}

	setRootCheckbox(checkedSporttakken, indeterminateSporttakken, moederId, models) {
		const context = this.context;
		let sporttakken = models;

		while (sporttakken.map(s => s.id).indexOf(moederId) === -1 && moederId != '00000000-0000-0000-0000-000000000000') {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}

		const moedersporttak = sporttakken.filter(s => s.id === moederId)[0];

		if (moedersporttak) {
			const checkedSubsporttakken = moedersporttak.subsporttakken && moedersporttak.subsporttakken.filter(s => checkedSporttakken.indexOf(s.id) > -1);
			const indeterminateSubsporttakken = moedersporttak.subsporttakken && moedersporttak.subsporttakken.filter(s => indeterminateSporttakken.indexOf(s.id) > -1);

			if ((checkedSubsporttakken && checkedSubsporttakken.length > 0 && checkedSubsporttakken.length !== moedersporttak.subsporttakken.length)
				|| (indeterminateSubsporttakken && indeterminateSubsporttakken.length > 0 && indeterminateSubsporttakken.length !== moedersporttak.subsporttakken.length)) {
				if (indeterminateSporttakken && indeterminateSporttakken.indexOf(moederId) === -1) {
					indeterminateSporttakken.push(moederId);
				}
			}
			else {
				if (indeterminateSporttakken && indeterminateSporttakken.indexOf(moedersporttak.id) !== -1) {
					const index = indeterminateSporttakken.indexOf(moedersporttak.id);
					indeterminateSporttakken.splice(index, 1);
				}
			}

			if (checkedSubsporttakken && checkedSubsporttakken.length === moedersporttak.subsporttakken.length) {
				if (checkedSporttakken.indexOf(moedersporttak.id) === -1) {
					checkedSporttakken.push(moedersporttak.id);
				}
			}
			else if (indeterminateSubsporttakken && indeterminateSubsporttakken.length === moedersporttak.subsporttakken.length) {
				if (checkedSporttakken.indexOf(moedersporttak.id) === -1) {
					checkedSporttakken.push(moedersporttak.id);
				}
			}
			else {
				if (checkedSporttakken && checkedSporttakken.indexOf(moedersporttak.id) !== -1) {
					const index = checkedSporttakken.indexOf(moedersporttak.id);
					checkedSporttakken.splice(index, 1);
				}
			}
		}

		if (moedersporttak && moedersporttak.moederId != '00000000-0000-0000-0000-000000000000') {
			this.setRootCheckbox(checkedSporttakken, indeterminateSporttakken, moedersporttak.moederId, sporttakken);
		}

		context.setState({
			checkedSporttakken,
			indeterminateSporttakken
		});
	}

	setChildCheckboxes(checkedSporttakken, indeterminateSporttakken, id) {
		const context = this.context;
		const state = context.state;
		const addSporttakActive = state.addSporttakActive;

		let sporttakken = addSporttakActive ?
			state.searchresults.map(x => mergeDeep({}, x))
			: state.models.map(x => mergeDeep({}, x));

		while (sporttakken.map(s => s.id).indexOf(id) === -1) {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}
		const sporttak = sporttakken.filter(s => s.id === id)[0];

		if (checkedSporttakken.indexOf(sporttak.id) > -1) {
			sporttak.subsporttakken.map((subsporttak) => {
				if (indeterminateSporttakken.indexOf(subsporttak.id) !== -1) {
					const index = indeterminateSporttakken.indexOf(subsporttak.id);
					indeterminateSporttakken.splice(index, 1);
				}
				if (checkedSporttakken.indexOf(subsporttak.id) === -1) {
					checkedSporttakken.push(subsporttak.id);
				}
			});
		}
		else {
			sporttak.subsporttakken.map((subsporttak) => {
				if (indeterminateSporttakken.indexOf(subsporttak.id) !== -1) {
					const index = indeterminateSporttakken.indexOf(subsporttak.id);
					indeterminateSporttakken.splice(index, 1);
				}
				if (checkedSporttakken.indexOf(subsporttak.id) !== -1) {
					const index = checkedSporttakken.indexOf(subsporttak.id);
					checkedSporttakken.splice(index, 1);
				}
			});
		}

		if (sporttak.subsporttakken) {
			sporttak.subsporttakken.map((subsporttak) => {
				this.setChildCheckboxes(checkedSporttakken, indeterminateSporttakken, subsporttak.id);
			});
		}
	}

	change(event) {
		const value = event.target.checked;
		const id = event.target.name.split('_')[0];
		const moederId = event.target.name.split('_')[1];
		const context = this.context;
		const state = context.state;

		const models = state.models.map(x => mergeDeep({}, x));

		const checkedSporttakken = assign([], state.checkedSporttakken);
		const indeterminateSporttakken = assign([], state.indeterminateSporttakken);

		if (value) {
			if (indeterminateSporttakken.indexOf(id) !== -1) {
				const index = indeterminateSporttakken.indexOf(id);
				indeterminateSporttakken.splice(index, 1);
			}
			if (checkedSporttakken.indexOf(id) === -1) {
				checkedSporttakken.push(id);
			}
		}
		else {
			if (indeterminateSporttakken.indexOf(id) !== -1) {
				const index = indeterminateSporttakken.indexOf(id);
				indeterminateSporttakken.splice(index, 1);
			}
			const index = checkedSporttakken.indexOf(id);
			if (checkedSporttakken.indexOf(id) !== -1) {
				checkedSporttakken.splice(index, 1);
			}
		}

		if (moederId != '00000000-0000-0000-0000-000000000000') {
			this.setRootCheckbox(checkedSporttakken, indeterminateSporttakken, moederId, models);
		}

		this.setChildCheckboxes(checkedSporttakken, indeterminateSporttakken, id);

		context.setState({
			models,
			hasUnsavedChanges: true,
			undoButtonDisabled: false,
			checkedSporttakken,
			indeterminateSporttakken,
			sporttakFilterHasFocus: false
		});
		this.context.state.hasUnsavedChanges === true || context.props.setHasUnsavedChanges(true);
	}

	changeAdd(event) {
		const value = event.target.checked;
		const id = event.target.name.split('_')[0];
		const moederId = event.target.name.split('_')[1];
		const context = this.context;
		const state = context.state;

		const searchresults = state.searchresults.map(x => mergeDeep({}, x));

		const checkedSporttakken = assign([], state.checkedSporttakken);
		const indeterminateSporttakken = assign([], state.indeterminateSporttakken);

		if (value) {
			if (indeterminateSporttakken.indexOf(id) !== -1) {
				const index = indeterminateSporttakken.indexOf(id);
				indeterminateSporttakken.splice(index, 1);
			}
			if (checkedSporttakken.indexOf(id) === -1) {
				checkedSporttakken.push(id);
			}
		}
		else {
			if (indeterminateSporttakken.indexOf(id) !== -1) {
				const index = indeterminateSporttakken.indexOf(id);
				indeterminateSporttakken.splice(index, 1);
			}
			const index = checkedSporttakken.indexOf(id);
			if (checkedSporttakken.indexOf(id) !== -1) {
				checkedSporttakken.splice(index, 1);
			}
		}

		if (moederId != '00000000-0000-0000-0000-000000000000') {
			this.setRootCheckbox(checkedSporttakken, indeterminateSporttakken, moederId, searchresults);
		}

		this.setChildCheckboxes(checkedSporttakken, indeterminateSporttakken, id);

		context.setState({
			searchresults,
			undoButtonDisabled: false,
			checkedSporttakken,
			indeterminateSporttakken,
			somethingChanged: true,
			totalSearchResults: searchresults.length,
			sporttakFilterHasFocus: false
		});
	}

	undo() {
		const context = this.context;
		const state = context.state;
		let checkedSporttakken = assign([], state.original.checkedSporttakken);
		let indeterminateSporttakken = assign([], state.original.indeterminateSporttakken);
		const models = state.original.models.map(x => mergeDeep({}, x));

		context.setState({
			models,
			checkedSporttakken,
			undoButtonDisabled: true,
			hasUnsavedChanges: false,
			indeterminateSporttakken,
			level: -1
		});
		this.context.state.hasUnsavedChanges === false || context.props.setHasUnsavedChanges(false);
	}

	increaseLevel(currentLevel) {
		const context = this.context;
		let level = context.state.level;

		if (level < currentLevel || level === -1) {
			context.setState({
				level: currentLevel
			});
		}
	}

	openAdd() {
		const context = this.context;
		const state = context.state;
		const stateBefore = mergeDeep({}, {
			models: state.models,
			checkedSporttakken: state.checkedSporttakken,
			undoButtonDisabled: !!state.undoButtonDisabled,
			indeterminateSporttakken: state.indeterminateSporttakken
		}, state.stateBefore);

		context.props.loadFederatieSporttakkenToevoegenPageLayout(state.sportclubNaam);

		context.setState({
			addSporttakActive: true,
			filter: '',
			searchresults: [],
			stateBefore,
			totalSearchResults: -1,
			sporttakFilterHasFocus: true
		});
	}

	continueAdd() {
		const context = this.context;
		const state = context.state;
		const models = state.models.map(x => mergeDeep({}, x));
		const searchresults = state.searchresults.map(x => mergeDeep({}, x));
		const checkedSporttakken = state.checkedSporttakken;
		const indeterminateSporttakken = state.indeterminateSporttakken;

		const markedSporttakken = checkedSporttakken.concat(indeterminateSporttakken);
		const existingSporttaken = models.map(s => s.id);

		const modelsToAdd = searchresults.filter(s => markedSporttakken.indexOf(s.id) > -1 && existingSporttaken.indexOf(s.id) == -1);

		const sporttakkenToLookup = modelsToAdd.map(s => s.id);
		this.listSporttakkenByIds(sporttakkenToLookup);

		const hasUnsavedChanges = state.somethingChanged;

		context.props.loadSportOrganisatieSporttakkenPageLayout(state.sportclubNaam);
		context.setState({
			addSporttakActive: false,
			hasUnsavedChanges,
			somethingChanged: false
		});
	}

	listSporttakkenByIds(ids) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		ajaxActions.started();
		sporttakApi.listSporttakkenByIds(ids)
			.then((response) => {
				ajaxActions.ended();
				this.processAddedModels(response.data, {}, '', false);
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex, true);
			});
	}

	cancelAdd() {
		const context = this.context;
		const state = context.state;
		const models = state.stateBefore.models.map(x => mergeDeep({}, x));
		const undoButtonDisabled = !!context.state.stateBefore.undoButtonDisabled;

		context.props.loadSportOrganisatieSporttakkenPageLayout(state.sportclubNaam);
		if (state.somethingChanged) {
			context.setState({
				hasUnsavedChangesOnAdd: true
			});
		}
		else {
			context.setState({
				addSporttakActive: false,
				models,
				undoButtonDisabled,
				hasUnsavedChangesOnAdd: false,
				level: -1
			});
		}
	}

	search() {
		const context = this.context;
		const state = context.state;
		const ajaxActions = context.props.ajaxActions;
		const filter = state.filter;

		if (filter) {
			ajaxActions.started();
			sporttakApi.listSporttakkenByFilter(filter)
				.then((response) => {
					ajaxActions.ended();
					this.processSearchModel(response.data);
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex, true);
				});
		}
	}

	processSearchModel(model) {
		const context = this.context;
		const state = context.state;
		const searchresults = model.sporttakken.map(x => mergeDeep({}, x));
		let checkedSporttakken = assign([], state.stateBefore.checkedSporttakken);
		let indeterminateSporttakken = assign([], state.stateBefore.indeterminateSporttakken);
		const level = -1;

		context.setState({
			searchresults,
			indeterminateSporttakken,
			checkedSporttakken,
			level,
			totalSearchResults: searchresults.length
		});
	}

	processAddedModels(model) {
		const context = this.context;
		const state = context.state;
		const newModels = model.sporttakken.map(x => mergeDeep({}, x));
		let models = state.models.map(x => mergeDeep({}, x));

		models = models.concat(newModels);
		context.state.checkedSporttakken.map(s => this.setRootCheckbox(context.state.checkedSporttakken, context.state.indeterminateSporttakken, s, models));

		context.setState({
			models,
			level: -1
		});
	}

	changeFilter(event) {
		const context = this.context;
		const value = event.target.value;

		context.setState({
			filter: value
		});
	}

	cancelUnsavedChanges() {
		const context = this.context;

		context.setState({
			hasUnsavedChangesOnAdd: false
		});
	}

	confirmUnsavedChanges() {
		const context = this.context;
		const state = context.state;
		const models = state.stateBefore.models.map(x => mergeDeep({}, x));
		const checkedSporttakken = state.stateBefore.checkedSporttakken;
		const indeterminateSporttakken = state.stateBefore.indeterminateSporttakken;
		const undoButtonDisabled = !!context.state.stateBefore.undoButtonDisabled;

		context.props.loadSportOrganisatieSporttakkenPageLayout(state.sportclubNaam);

		context.setState({
			somethingChanged: false,
			addSporttakActive: false,
			models,
			undoButtonDisabled,
			hasUnsavedChangesOnAdd: false,
			checkedSporttakken,
			indeterminateSporttakken,
			level: -1
		});
	}
}
